import type { ThemeConfig } from "antd";

const theme: ThemeConfig = {
  token: {
    colorPrimary: "#d91d22",
    borderRadius: 4,
    borderRadiusLG: 4,
    lineHeight: 1.3,
    colorBorder: "#dddddd",
  },
  components: {
    Button: {
      defaultBg: "#d91d22",
    },
    InputNumber: {},
    Table: {
      headerBg: "#f7f8f9",
      headerColor: "#000018",
      cellFontSize: 16,
    },
    Form: {
      labelColor: "#757575",
      labelRequiredMarkColor: "#d91d22",
    },
    Input: {
      paddingInlineLG: 16,
    },
    Modal: {
      titleColor: "#000018",
    },
  },
};

export default theme;
